import SendNote, { SendNoteProps } from "./SendNote";

export { SendNote, SendNoteProps };

export default SendNote;
